import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import StockQuantityInput from "./StockQuantityInput";
import { channelColor } from "./channelColor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const Period = (props) => {
  // Important pour utiliser la fonction moment day avec le nom des jours
  require("moment/locale/en-gb.js");

  const {
    keyPeriod,
    line,
    productName,
    productId,
    period,
    type,
    typeLabel,
    showChannel,
    updateForecastStocksTempo,
  } = props;

  const weekNumber = moment(period.dates.start).format("W");

  // Calcule la date puis envoie la maj de la donnée au component parent avec updateForecastStocksTempo
  const onChangeStock = (stockQty, dayName, periodStart) => {
    dayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
    let date = moment(periodStart).day(dayName).week(weekNumber);
    date.add(1, 'days');
    updateForecastStocksTempo({
      productId: productId,
      date: date,
      stockQty: stockQty,
      type: type,
    });
  };

  return (
    <Container>
      {showChannel && <Channel channel={type}>{typeLabel}</Channel>}
      <Head type={line} channel={showChannel ? type : null}>
        <Row noGutters>
          <Col xs={3}>
            <p>
              {moment(period.dates.start).format("DD/MM/YY")}
              <br />
              {moment(period.dates.end).format("DD/MM/YY")}
            </p>
          </Col>
          <Col xs={3}>St</Col>
          <Col xs={2}>Co</Col>
          <Col xs={1}>Re</Col>
          <Col xs={1}>Ajst</Col>
          <Col xs={2}>Rupt</Col>
        </Row>
      </Head>
      <Info>
        {Object.entries(period.days).length === 0 && 'Produit indisponible dans cette période' }
        {Object.keys(period.days).map((day, key) => (
          <Day noGutters key={keyPeriod+"-"+key}>
            <Col xs={3}>
              {day === "monday"
                ? "Lu"
                : day === "tuesday"
                ? "Ma"
                : day === "wednesday"
                ? "Me"
                : day === "thursday"
                ? "Je"
                : day === "friday"
                ? "Ve"
                : day === "saturday"
                ? "Sa"
                : day === "sunday"
                ? "Di"
                : null}
            </Col>
            <Stock xs={3}>
              <StockQuantityInput
                quantity={period.days[day].stock}
                // onChangeStock={onChangeStock}
                onChange={(stockQty) => onChangeStock(stockQty, day, period.dates.start)}
                disabled={moment() > moment(period.dates.start).day(day).week(weekNumber)}
                isAvailable={period.days[day].isAvailable}
                index={key + 1}
              />
            </Stock>
            <Col xs={2}>{period.days[day].order}</Col>
            <Col xs={1}>
              {period.days[day].tweakStock ?
                  <>
                    {(period.days[day].tweakStock !== -1)
                      ? period.days[day].tweakStock - period.days[day].order
                      : "-"
                    }
                  </>
                :
                  <>
                    {(period.days[day].stock !== -1)
                      ? period.days[day].stock - period.days[day].order
                      : "-"
                    }
                  </>
              }
            </Col>
            <Col xs={1}>
              {period.days[day].tweakStock !== null ?
                <Warning>
                    <FontAwesomeIcon icon={faExclamationTriangle} /> {period.days[day].tweakStock !== -1 ? period.days[day].tweakStock : "Illimité"}
                </Warning>
                :
                "-"
              }
            </Col>
            <Col xs={2}>
              <i>
                <small>
                  {((period.days[day].outOfStockAt && period.days[day].stock > -1 && period.days[day].order > 0 &&
                  period.days[day].stock - period.days[day].order < 1) && period.days[day].tweakStock === null) || (period.days[day].outOfStockAt && period.days[day].tweakStock > -1 && period.days[day].tweakStock !== null && period.days[day].order > 0 &&
                  period.days[day].tweakStock - period.days[day].order < 1)
                    ? moment(period.days[day].outOfStockAt).format("LT")
                    : ((!period.days[day].outOfStockAt && period.days[day].stock > -1 && period.days[day].order > 0 &&
                    period.days[day].stock - period.days[day].order < 1) && period.days[day].tweakStock === null) || (!period.days[day].outOfStockAt && period.days[day].tweakStock > -1 && period.days[day].tweakStock !== null && period.days[day].order > 0 &&
                    period.days[day].tweakStock - period.days[day].order < 1)
                      ? period.days[day].update ? moment(period.days[day].update).format("LT") : "N/C"
                      : "N/C"
                  }
                </small>
              </i>
            </Col>
          </Day>
        ))}
      </Info>
      <Title type={line}>{productName}</Title>
    </Container>
  );
};

const Container = styled.div`
  width: 30%;
  min-width: 370px;
  display: inline-block;
  vertical-align: top;
  white-space: normal;
  padding: 0.5rem;
`;


const Warning = styled.span`
  color: ${(props) => props.theme.colors.red};
`;

const Day = styled(Row)`
  border-bottom: 1px solid #dedede;
`;

const Stock = styled(Col)`
  color: ${(props) => props.theme.colors.green};
  height: 26px;
`;

const Title = styled.h2`
  text-align: center;
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  background-color: ${(props) =>
    props.type === "impair"
      ? props.theme.colors.green
      : props.theme.colors.black};
  color: white;
  margin: 0rem;
  padding: 0.5rem;
  border-radius: 0.4rem;
  border-top-right-radius: 0rem;
  border-top-left-radius: 0rem;
  box-shadow: 0 10px 10px 2px rgba(0, 0, 0, 0.2);
`;

const Info = styled.div`
  background-color: #f8f8f6;
  padding: 0.5rem;
  box-shadow: 0 10px 10px 2px rgba(0, 0, 0, 0.2);
`;

const Channel = styled.div`
  text-align: center;
  font-size: 0.9rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  padding: 0.3rem 0.5rem;
  background-color: ${(props) => channelColor(props.theme, props.channel)};
  color: white;
  border-radius: 0.4rem;
  border-bottom-right-radius: 0rem;
  border-bottom-left-radius: 0rem;
`;

const Head = styled.div`
  box-shadow: 0 10px 10px 2px rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  border-top: ${(props) =>
    props.channel
      ? `solid 3px ${channelColor(props.theme, props.channel)}`
      : "none"};
  background-color: ${(props) =>
    props.type === "impair"
      ? props.theme.colors.green
      : props.theme.colors.black};
  color: white;
  border-top-left-radius: ${(props) => (props.channel ? "0rem" : "0.4rem")};
  border-top-right-radius: ${(props) => (props.channel ? "0rem" : "0.4rem")};
  p {
    margin-bottom: 0rem;
    line-height: 1;
    font-weight: bold;
    font-size: 0.8rem;
  }
`;

Period.propTypes = {
  line: PropTypes.string,
  productName: PropTypes.string,
  productId: PropTypes.number,
  period: PropTypes.object,
  type: PropTypes.string,
  typeLabel: PropTypes.string,
  showChannel: PropTypes.bool,
  updateForecastStocksTempo: PropTypes.func,
};

export default Period;
